export default {
  aboutPage: {
    seoTitle: 'Sobre Geofleet — Software de gestión de entregas con IA',
    seoDescription:
      'Geofleet crea software de gestión de entregas con un Copilot de IA, usado por más de 100 clientes en más de 20 países. Con certificación SOC 2 e ISO 27001, precios públicos desde $49 al mes para 3 conductores.',
    badge: 'Sobre Geofleet',
    title: 'Creamos el centro de comando',
    titleHighlight: 'para equipos de entrega',
    lead:
      'Geofleet es un software de gestión de entregas para equipos que operan su propia flota. Los despachadores planifican y siguen cada parada desde un solo centro de comando, los conductores trabajan desde una sola app y los clientes siguen su pedido con un enlace de seguimiento en vivo. Un Copilot de IA se encarga del trabajo repetitivo, dentro de los permisos que definas.',
    stats: [
      { value: '100+', label: 'Clientes' },
      { value: '20+', label: 'Países' },
      { value: '50+', label: 'Integraciones' },
      { value: '99,99%', label: 'Disponibilidad' },
    ],
    heroImageAlt: 'Centro de comando de Geofleet con mapa de entregas en vivo, KPIs y los pedidos del día',

    missionKicker: 'Por qué existimos',
    missionTitle: 'La mayoría de las entregas todavía se gestionan con chats y hojas de cálculo',
    missionBody: [
      'En la mayoría de las operaciones de entrega, el plan vive en una hoja de cálculo, el despacho se hace en grupos de chat y los clientes llaman para preguntar dónde está su pedido. Cada conductor que se retrasa se convierte en una ronda de llamadas.',
      'Creamos Geofleet para reunir ese trabajo en un solo lugar. Entran los pedidos, se planifican las rutas, se despacha a los conductores, se mantiene informados a los clientes y cada entrega termina con una prueba. Cuando algo se desvía, el centro de comando lo muestra primero y Copilot sugiere la solución.',
    ],
    missionQuote: 'Nuestro objetivo: que cada equipo de entrega tenga las herramientas de los grandes transportistas, sin un largo proceso de venta empresarial.',

    principlesKicker: 'Cómo trabajamos',
    principlesTitle: 'En qué creemos',
    principles: [
      {
        title: 'El precio está en la página',
        body: 'Precios públicos, desde $49 al mes para 3 conductores. Deberías saber cuánto cuesta antes de hablar con nadie.',
      },
      {
        title: 'IA con límites',
        body: 'Copilot y nuestros agentes de IA solo actúan dentro del rol de cada usuario. Ellos proponen, las personas confirman y cada cambio queda registrado.',
      },
      {
        title: 'Basado en datos en vivo',
        body: 'Cada respuesta y sugerencia sale de lo que está pasando en la calle en este momento, no de texto genérico de IA.',
      },
      {
        title: 'La seguridad no es opcional',
        body: 'Geofleet cuenta con certificación SOC 2 e ISO 27001, con datos cifrados en reposo y en tránsito y acceso basado en roles en toda la plataforma.',
      },
    ],

    productKicker: 'Qué construimos',
    productTitle: 'Una plataforma, del pedido a la prueba de entrega',
    products: [
      { title: 'Centro de comando', body: 'Mapa en vivo, excepciones priorizadas y todos los pedidos en una sola vista.', href: '/how-it-works' },
      { title: 'Copilot y agentes de IA', body: 'Pregunta en lenguaje natural, automatiza el despacho y resuelve excepciones.', href: '/features/ai-agents' },
      { title: 'Planificador de rutas', body: 'Rutas optimizadas con ventanas horarias, capacidad y tráfico.', href: '/features/route-planner' },
      { title: 'App del conductor', body: 'Navegación, prueba de entrega y asistencia, incluso sin conexión.', href: '/features/driver-app' },
      { title: 'Seguimiento con tu marca', body: 'Un enlace de seguimiento en vivo que los clientes abren en cualquier navegador.', href: '/features/branded-tracking' },
      { title: 'Informes y analítica', body: 'Tasa de puntualidad, coste por entrega y fichas de conductores.', href: '/features/reports-analytics' },
    ],

    industriesKicker: 'A quién servimos',
    industriesTitle: 'Equipos que entregan todos los días',
    industriesBody:
      'Restaurantes, farmacias, mensajerías, supermercados, comercios, distribuidores y equipos de servicio técnico usan Geofleet en más de 20 países, desde flotas de 10 conductores hasta operaciones con varios hubs.',
    industriesCta: 'Ver todas las industrias',

    trustKicker: 'Confianza y seguridad',
    trustTitle: 'Hecho para que puedas confiar en él',
    trustItems: [
      { title: 'SOC 2', body: 'Controles de seguridad auditados de forma independiente.' },
      { title: 'ISO 27001', body: 'Gestión de la seguridad de la información certificada.' },
      { title: '99,99% de disponibilidad', body: 'Una plataforma sobre la que tu despacho puede trabajar todo el día.' },
      { title: 'Cifrado y control de acceso', body: 'Datos cifrados en reposo y en tránsito, con permisos basados en roles y registros de auditoría.' },
    ],
    trustCta: 'Solicita nuestra documentación de seguridad',

    connectKicker: 'Trabaja con nosotros',
    connectTitle: 'Ponte en contacto',
    connectCards: [
      { title: 'Prueba Geofleet', body: 'Empieza con Geofleet Lite y tus propios pedidos, desde $49 al mes para 3 conductores.', cta: 'Empieza ahora' },
      { title: 'Habla con nuestro equipo', body: 'Reserva una demo y repasaremos contigo tu flujo de entregas.', cta: 'Reserva una demo' },
      { title: 'Hazte socio', body: 'Revende o integra Geofleet, con un portal de socios de autoservicio.', cta: 'Programa de socios' },
    ],
    contactLine: 'Consultas generales:',
  },
};
